import { createSlice } from '@reduxjs/toolkit';

import { handleGetDrugClasses } from './actions';
import { IDrugClassesState } from './slice.interface';

const initialState: IDrugClassesState = {
  data: [],
  isLoading: false,
  isReady: false,
  error: false,
};

export const drugClassesSlice = createSlice({
  name: 'drug-classes',
  initialState,
  reducers: {
    removeDrugClasses: (state: IDrugClassesState) => {
      state.data = [];
      state.isLoading = false;
      state.isReady = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetDrugClasses.pending, (state: IDrugClassesState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetDrugClasses.rejected, (state: IDrugClassesState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetDrugClasses.fulfilled, (state: IDrugClassesState, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
        state.isReady = true;
      });
  },
});

export const { removeDrugClasses } = drugClassesSlice.actions;

export default drugClassesSlice.reducer;
